var React = require('react');

function LinkedIn (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0zm-4.175 21h-3.4a.427.427 0 00-.425.429V32.57c0 .237.19.429.425.429h3.4a.427.427 0 00.425-.429V21.43a.427.427 0 00-.425-.429zm.391-3.857c0-1.184-.944-2.143-2.108-2.143-1.165 0-2.108.96-2.108 2.143 0 1.184.944 2.143 2.108 2.143 1.165 0 2.108-.96 2.108-2.143zM32.575 33h-2.55a.427.427 0 01-.425-.429v-6.428A2.134 2.134 0 0027.475 24c-1.174 0-2.125.96-2.125 2.143v6.428c0 .237-.19.429-.425.429h-2.55a.427.427 0 01-.425-.429V21.43c0-.237.19-.429.425-.429h2.55c.235 0 .425.192.425.429a.346.346 0 00.612.231 3.565 3.565 0 012.695-1.089c2.532 0 4.343 1.569 4.343 4.8v7.2c0 .237-.19.429-.425.429z"}));
}

LinkedIn.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = LinkedIn;

LinkedIn.default = LinkedIn;
